import { render, staticRenderFns } from "./Certifications.vue?vue&type=template&id=297decef&"
import script from "./Certifications.vue?vue&type=script&lang=js&"
export * from "./Certifications.vue?vue&type=script&lang=js&"
import style0 from "../../assets/styles/swiper.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./Certifications.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports